<template>
    <div class="photo-viewer" @click="bgClick">
      <img
        :src="path"
        @click="photoClick"
      />
      <button class="remove-btn" v-if="removable" @click="onRemove">Remove</button>
    </div>
</template>

<script>
    export default {

      name: "PhotoViewer",

      props: {
        path: String,
        removable: {
          type: Boolean,
          defaultValue: false
        }
      },

      data() {
        return {}
      },

      methods: {

        photoClick() {
          //console.log('PhotoViewer.photoClick()');
          this.$emit('close');
        },

        bgClick() {
          //console.log('PhotoViewer.bgClick()');
          this.$emit('close');
        },

        onRemove() {
          //console.log('PhotoViewer.onRemove()');
          this.$emit('remove');
        }

      }

    }
</script>

<style scoped>

  .photo-viewer {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);;
    position: fixed;
    top:0;
    left:0;
  }

  .remove-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  div img {
    display: block;
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow: 2px 2px 5px grey;
  }

</style>
